import {CommonModule, registerLocaleData} from '@angular/common';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import en from '@angular/common/locales/en';
import ru from '@angular/common/locales/ru';
import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServiceWorkerModule} from '@angular/service-worker';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {NbAlertModule, NbButtonModule, NbCardModule, NbInputModule, NbLayoutModule, NbThemeModule} from '@nebular/theme';
import {LOADING_BAR_CONFIG, LoadingBarModule} from '@ngx-loading-bar/core';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {LoadingBarRouterModule} from '@ngx-loading-bar/router';
import {TuiRoot} from '@taiga-ui/core';
import {provideEventPlugins} from '@taiga-ui/event-plugins';
import {TUI_LANGUAGE} from '@taiga-ui/i18n';
import {AuthModule} from 'compob2b-auth';
import {CompoErrorHandler, Environment, SharedModule} from 'compob2b-libs';
import {of} from 'rxjs';
import {environment} from '../environments/environment';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CabinetModule} from './cabinet/cabinet.module';

registerLocaleData(ru);
registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    CabinetModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TuiRoot,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production && environment.serviceWorkers,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    NbThemeModule.forRoot({name: 'default'}),
    NbLayoutModule,
    AuthModule.forRoot(environment),
    NbEvaIconsModule,
    NbAlertModule,
    NbInputModule,
    NbCardModule,
    NbButtonModule,
    SharedModule.forRoot(environment),
    ReactiveFormsModule,
    LoadingBarModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
  ],
  providers: [
    {provide: ErrorHandler, useClass: CompoErrorHandler},
    {provide: LOADING_BAR_CONFIG, useValue: {latencyThreshold: 200}},
    {provide: LOCALE_ID, useValue: environment.locale},
    {provide: TUI_LANGUAGE, useValue: of(environment.tuiLanguage)},
    {provide: 'environment', useValue: environment},
    {provide: environment, useValue: environment},
    {provide: Environment, useValue: environment},
    provideEventPlugins(),
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule {
}
